import { render } from "./TextEditor.vue?vue&type=template&id=24e1a784&ts=true"
import script from "./TextEditor.vue?vue&type=script&lang=ts"
export * from "./TextEditor.vue?vue&type=script&lang=ts"

import "./TextEditor.vue?vue&type=style&index=0&id=24e1a784&lang=css"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__